import types from './types';

const getTimeOffRequestsRequest = (start = '', end = '') => ({
  type: types.GET_TIME_OFF_REQUESTS_REQUEST,
  start,
  end
});

/**
 * Successfully retrieved time off requests
 * @param {Object[]} requests
 * @param {Object} groupedByEmployeeId
 */
const getTimeOffRequestsSucces = (requests, groupedByEmployeeId) => ({
  type: types.GET_TIME_OFF_REQUESTS_SUCCESS,
  requests,
  groupedByEmployeeId
});

const getTimeOffRequestsFailure = () => ({
  type: types.GET_TIME_OFF_REQUESTS_FAILURE
});

/**
 * Approve or deny a time off request
 * @param {Object[]} requests - Array of objects with the following properties
 * - {Number} id - id of request to approve or deny
 * - {String} status - `approve` or `reject`
 * - {Number} hoursApproved - (float)
 */
const updateTimeOffRequestStatusRequest = (requests) => ({
  type: types.UPDATE_TIME_OFF_REQUEST_STATUS_REQUEST,
  requests
});

/**
 * Successfully approved or denied a shift(s)
 * @param {Object[]} requests
 */
const updateTimeOffRequestStatusSuccess = requests => ({
  type: types.UPDATE_TIME_OFF_REQUEST_STATUS_SUCCESS,
  requests
});

const updateTimeOffRequestStatusFailure = () => ({
  type: types.UPDATE_TIME_OFF_REQUEST_STATUS_FAILURE
});

/**
 * Director / Admin edits a pending time off request
 *
 * @param {Number} id
 * @param {String} requestType
 * @param {String} timeOffType
 * @param {String} start
 * @param {String} end
 * @param {String} description
 */
const editRequest = (
  id,
  requestType,
  timeOffType,
  start,
  end,
  description
) => ({
  type: types.EDIT_TIME_OFF_REQUEST_REQUEST,
  id,
  requestType,
  timeOffType,
  start,
  end,
  description
});

/**
 * Use the changes to update the current object in redux
 *
 * @param {Number} id
 * @param {String} requestType
 * @param {String} timeOffType
 * @param {String} start
 * @param {String} end
 * @param {String} description
 */
const editRequestSuccess = (
  id,
  requestType,
  timeOffType,
  start,
  end,
  description
) => ({
  type: types.EDIT_TIME_OFF_REQUEST_SUCCESS,
  id,
  requestType,
  timeOffType,
  start,
  end,
  description
});

const editRequestFailure = () => ({
  type: types.EDIT_TIME_OFF_REQUEST_FAILURE
});

/**
 * @param {Number[]} ids
 */
const archiveTimeOffRequest = (ids) => ({
  type: types.ARCHIVE_TIME_OFF_REQUEST_REQUEST,
  ids
});

const archiveTimeOffRequestSuccess = (ids) => ({
  type: types.ARCHIVE_TIME_OFF_REQUEST_SUCCESS,
  ids
});

const archiveTimeOffRequestFailure = () => ({
  type: types.ARCHIVE_TIME_OFF_REQUEST_FAILURE
});

const managerCreateEmployeeTimeOffRequest = request => ({
  type: types.MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_REQUEST,
  request
});

const managerCreateEmployeeTimeOffSuccess = request => ({
  type: types.MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_SUCCESS,
  request
});

const managerCreateEmployeeTimeOffFailure = () => ({
  type: types.MANAGER_CREATE_EMPLOYEE_TIME_OFF_REQUEST_FAILURE
});

export default {
  getTimeOffRequestsRequest,
  getTimeOffRequestsSucces,
  getTimeOffRequestsFailure,
  updateTimeOffRequestStatusRequest,
  updateTimeOffRequestStatusSuccess,
  updateTimeOffRequestStatusFailure,
  editRequest,
  editRequestSuccess,
  editRequestFailure,
  archiveTimeOffRequest,
  archiveTimeOffRequestSuccess,
  archiveTimeOffRequestFailure,
  managerCreateEmployeeTimeOffRequest,
  managerCreateEmployeeTimeOffSuccess,
  managerCreateEmployeeTimeOffFailure
};
